import useUserQuery from '../behavior/init/hooks/useUserQuery';

function useUser() {
  const { data: user } = useUserQuery();
  return user;
}

export default useUser;
